import styled from 'styled-components'
import { Flex, Text } from 'vvs-uikit'

import BaseCollapse, { BaseCollapseProps } from './Base'

const PrimaryThemeCollapse = ({ title, children }: Pick<BaseCollapseProps, 'title' | 'children'>) => {
  return (
    <OuterWrapper>
      <BaseCollapse title={<Header>{title}</Header>} titleBarProps={{ padding: '24px' }}>
        <ContentWrapper>{children}</ContentWrapper>
      </BaseCollapse>
    </OuterWrapper>
  )
}

export default PrimaryThemeCollapse

const OuterWrapper = styled(Flex)`
  background: ${({ theme }) => theme.card.background};

  ${({ theme }) => theme.mediaQueries.xxl} {
    max-width: 770px;
  }
`
const Header = styled(Text)`
  font-size: 20px;
  font-weight: 500;
  align-self: center;
`

const ContentWrapper = styled.pre`
  width: 100%;
  padding: 24px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  white-space: pre-wrap;
  background: ${({ theme }) => theme.colors.backgroundAlt2};
  color: ${({ theme }) => theme.colors.textSubtle};
`
